import StoreApplicationState from "@store/Store/StoreApplicationState";

export const getImpression = (state: StoreApplicationState) => {
    const impressions = state.store.data.analytics.impressions;

    return impressions;
};
